export default __webpack_public_path__ + "static/media/alert-triangle.ad851f2b.svg";